module.exports = __webpack_public_path__ + "img/CL.63ef3f20.webp";